/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        asterisk: {
            color: 'red',
        },
        formContainer: {
            display: "flex",
            width: "90%",
            flexDirection: "column",
            alignSelf: "center"
        },
        loaderContainer: {
            display: "flex",
            minHeight: theme.spacing(20),
            alignItems: "center",
            justifyContent: "center"
        },
        textLabel: {
            marginBottom: theme.spacing(1.5),
            fontFamily: 'GilmerMedium',
            fontSize: '13px',
            color: '#1D2028',
            lineHeight: '24px'
        },
        textLabelWithAsterisk: {
            marginBottom: theme.spacing(1.5),
            marginTop: theme.spacing(-0.5),
            fontFamily: 'GilmerMedium',
            fontSize: '13px',
            color: '#1D2028',
            lineHeight: '24px'
        },
        textInput: {
            width: "100%",
            '& .MuiInputBase-input': {
                fontSize: 14
            },
            '& .MuiOutlinedInput-root': {
                height: theme.spacing(6)
            },
            '& .MuiFormHelperText-contained': {
                marginRight: 0,
                minHeight: theme.spacing(3.75)
            }
        },
        multiLineInput: {
            width: "100%",
            '& .MuiInputBase-input': {
                fontSize: 14
            },
            '& .MuiFormHelperText-root.Mui-error': {
                background: "url('/images/warning-red.svg') no-repeat left top",
                margin: 0,
                paddingLeft: theme.spacing(3),
                marginTop: theme.spacing(1),
                color: "#EA4C4D"
            }
        },
        selectBox: {
            height: theme.spacing(6),
            width: "100%"
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[200]
        },
        createApiDialogContent: {
            paddingTop: `${theme.spacing(2)}px !important`
        },
        primaryTitle: {
            color: '#222228',
            textAlign: "center",
            fontFamily: 'GilmerBold',
            fontSize: '29px'
        },
        customWidth: {
            borderRadius: '12px',
            maxWidth: theme.spacing(87.5),
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(4)
        },
        dialogBtn: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            fontSize: 13,
            fontFamily: 'GilmerMedium'
        },
        cancelBtn: {
            marginRight: theme.spacing(1),
            height: theme.spacing(5),
            fontSize: 13,
            fontFamily: 'GilmerMedium'
        },
        dropdownStyle: {
            backgroundColor: "#fff",
            boxSizing: "border-box",
            width: "auto",
            border: "1px solid #DEE0E7",
            borderRadius: "5px",
            boxShadow: "0 5px 10px -3px rgba(50,50,77,0.1)",
            color: "#222228",
            marginTop: '0.25rem'
        },
        warningIcon: {
            height: theme.spacing(2.125),
            width: theme.spacing(2.125),
            marginRight: theme.spacing(1),
            marginLeft: -theme.spacing(1)
        },
        helperText: {
            display: "flex",
            alignItems: "center",
            fontSize: 10.5
        },
        textField: {
            width: theme.spacing(71.5),
            borderRadius: theme.spacing(0.625),
            backgroundColor: theme.palette.common.white,
            boxShadow: 'inset 0 0 0 1px #dee0e7, 0 1px 2px -1px rgba(0,0,0,0.08)',
            border: 1,
            '& .MuiOutlinedInput-input': {
              color: theme.palette.grey[500],
              paddingLeft: theme.spacing(1),
            },
            '& .MuiOutlinedInput-root': {
              height: 'auto',
            },
        },
        tag: {
            '& .MuiAutocomplete-tag': {
                backgroundColor: theme.palette.secondary.light,
                height: theme.spacing(3),
                marginBottom: theme.spacing(1),
                borderRadius: theme.spacing(0.625),
                position: "relative",
                zIndex: 0,
                border: "1px solid #979797",
                "& .MuiChip-label": {
                  color: theme.palette.secondary.dark,
                },
                "& .MuiChip-deleteIcon": {
                  color: theme.palette.secondary.main,
                },
            },
        }
    })
);
